/* Surface Gaming skin customizer — MODEL half.
   Loads first, parses #sgData, and publishes window.SG_MODEL for the view half
   (sg-customizer.js). Nothing here touches the DOM beyond reading #sgData.

   Full notes: project doc claude/customizer-migration-progress.md

   DEVICE RECORD — when the product carries a `custom.device_model` metaobject,
   parts, labels, sub-models, allowed materials and the default material all
   come from that one record, so a page is configured in the Shopify admin
   rather than in code. A product without one still renders from its own
   `part /` and `sub /` config variants, which is what let the catalogue
   migrate one model at a time.

   A part is three fields:
     key    permanent, written onto the order     "Left_Side"
     file   filename token(s) drawn for this part ["Side"] or ["Body","Body_Back"]
     label  what the shopper reads                "Left side"
   `file` is a list so a merged part — the Basilisk's "Sides" — or a part shot
   in two pieces — the G502 X's "Top" — draws every overlay it needs, without
   renaming a single image already on the CDN.

   PRESETS — `custom.preset` maps part keys to material codes. SG Theme and
   Featured products land on that combination, fully editable.

   ADD-ONS — variants are matched by the SET of their option tokens, not by
   option position, because "& Extra Body Piece" sits in option2 on one variant
   and option3 on another. Some products also carry a preset marker such as
   "(theme)" in one of those slots. The base variant is found first (fewest
   tokens, cheapest on a tie) and its tokens are subtracted from every
   comparison, so a marker can never become a checkbox.

   IMAGE NAMING
     <prefix>_Base.jpg                        G502_Base.jpg
     <prefix>_<file>_<code>.png               g502_Left_Click_br212.png
   Extra angles add a _view<token>_ segment straight after the prefix.
   The view token is matched only inside _view..._ so it can never collide with
   a part whose file token is "Side".
*/
window.SG_MODEL = (function(){
  "use strict";
  var node = document.getElementById("sgData");
  if(!node) return null;
  var DATA;
  try { DATA = JSON.parse(node.textContent); } catch(e){ return null; }

  var DEV = DATA.device || null;
  var PRESET = DATA.preset || null;
  var PRESET_NAME = DATA.presetName || "";
  var VARS = DATA.variants || [];
  var IMGS = DATA.images || {};

  var MATS = (DATA.materials || []).filter(function(m){ return m.code; })
    .sort(function(a,b){ return (a.position||999) - (b.position||999); });

  var byCode = {};
  MATS.forEach(function(m){ byCode[m.code] = m; });
  var BLANK = byCode["_xblank"] ? "_xblank" : null;

  /* parts */
  function normPart(p){
    var key = p.key || "";
    var file = (p.file && p.file.length) ? p.file.slice() : [key];
    return { key: key, file: file, label: p.label || key.replace(/_/g, " ") };
  }
  var PARTS = (DEV && DEV.parts && DEV.parts.length)
    ? DEV.parts.filter(function(p){ return p && p.key; }).map(normPart)
    : (DATA.parts || []).map(function(k){ return normPart({ key: k }); });

  var SUBS = (DEV && DEV.sub_models && DEV.sub_models.length)
    ? DEV.sub_models : (DATA.submodels || []);

  if(!MATS.length || !PARTS.length) return null;

  /* variants: base detection, then add-on tokens */
  function tokensOf(v){
    var t = [];
    if(v.o2 && v.o2 !== "-") t.push(v.o2);
    if(v.o3 && v.o3 !== "-") t.push(v.o3);
    return t;
  }
  var BASE = null;
  VARS.forEach(function(v){
    if(!BASE){ BASE = v; return; }
    var n = tokensOf(v).length, bn = tokensOf(BASE).length;
    if(n < bn || (n === bn && (v.price || 0) < (BASE.price || 0))) BASE = v;
  });
  var BASETOK = BASE ? tokensOf(BASE) : [];

  function addonsOf(v){
    return tokensOf(v).filter(function(t){ return BASETOK.indexOf(t) === -1; });
  }
  var TOKENS = [];
  VARS.forEach(function(v){
    addonsOf(v).forEach(function(t){ if(TOKENS.indexOf(t) === -1) TOKENS.push(t); });
  });

  function sameSet(a, b){
    if(a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){ if(b.indexOf(a[i]) === -1) return false; }
    return true;
  }
  function variantForSet(sel){
    for(var i = 0; i < VARS.length; i++){ if(sameSet(addonsOf(VARS[i]), sel)) return VARS[i]; }
    return null;
  }

  function plain(s){ return String(s || "").replace(/<[^>]*>/g, ""); }
  function amountOf(v){
    if(!v) return 0;
    var n = plain(v.priceText).replace(/[^0-9.,]/g, "").replace(/,/g, "");
    var f = parseFloat(n);
    return isNaN(f) ? (v.price || 0) / 100 : f;
  }
  function symbol(){
    var m = plain((VARS[0] || {}).priceText).match(/^[^0-9]*/);
    return m && m[0] ? m[0] : "$";
  }

  /* --- edit-from-cart ---------------------------------------------------
     The cart's Edit link carries the LINE KEY, not the configuration:
     ?edit=<key>. The line already holds SubModel, one property per part, and
     a variant id that encodes the add-ons, so the view restores the whole
     design by reading /cart.js — nothing has to be encoded in the URL, and
     no material name has to be mapped twice. */
  function editKey(){
    var m = location.search.match(/[?&]edit=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }
  function codeByName(n){
    for(var i = 0; i < MATS.length; i++){ if(MATS[i].name === n) return MATS[i].code; }
    return "";
  }
  /* null means that variant is not on this product — a stale or foreign key */
  function addonsOfVariant(id){
    for(var i = 0; i < VARS.length; i++){
      if(String(VARS[i].id) === String(id)) return addonsOf(VARS[i]);
    }
    return null;
  }

  /* angles */
  var VIEW_RE = /_view([a-z0-9]+)_/i;
  var imgKeys = Object.keys(IMGS);
  function viewToken(fn){
    var m = fn.toLowerCase().match(VIEW_RE);
    return m ? m[1] : "";
  }
  var ANGLES = [""];
  imgKeys.forEach(function(k){
    var t = viewToken(k);
    if(t && ANGLES.indexOf(t) === -1) ANGLES.push(t);
  });
  var ANGLE_LABELS = {
    "": "Main view", top: "Top", side: "Side", left: "Left side", right: "Right side",
    front: "Front", frontq: "Front three-quarter", rear: "Rear", rearq: "Rear three-quarter",
    back: "Back", bottom: "Underside", underside: "Underside", angle: "Angled", palm: "Palm rest"
  };
  function angleLabel(a){ return ANGLE_LABELS[a] || (a.charAt(0).toUpperCase() + a.slice(1)); }

  /* image lookups */
  var baseCache = {};
  function baseFor(angle){
    if(baseCache[angle] !== undefined) return baseCache[angle];
    var found = "";
    for(var i = 0; i < imgKeys.length; i++){
      if(imgKeys[i].toLowerCase().indexOf("_base") === -1) continue;
      if(viewToken(imgKeys[i]) !== angle) continue;
      found = IMGS[imgKeys[i]];
      break;
    }
    baseCache[angle] = found;
    return found;
  }
  var layerCache = {};
  function findLayer(angle, token, code){
    var ck = angle + "|" + token + "|" + code;
    if(layerCache[ck] !== undefined) return layerCache[ck];
    var needle = ("_" + token + "_" + code).toLowerCase();
    var found = "";
    for(var i = 0; i < imgKeys.length; i++){
      if(viewToken(imgKeys[i]) !== angle) continue;
      var lf = imgKeys[i].toLowerCase();
      var at = lf.indexOf(needle);
      if(at > -1){
        var after = lf.charAt(at + needle.length);
        if(after === "." || after === "_"){ found = IMGS[imgKeys[i]]; break; }
      }
    }
    layerCache[ck] = found;
    return found;
  }
  function layersFor(angle, part, code){
    var out = [];
    part.file.forEach(function(tok){
      var u = findLayer(angle, tok, code);
      if(u) out.push(u);
    });
    return out;
  }
  function swatchFor(m){
    if(m.swatch) return m.swatch + (m.swatch.indexOf("?") > -1 ? "&" : "?") + "width=140";
    for(var i = 0; i < PARTS.length; i++){
      var l = layersFor("", PARTS[i], m.code);
      if(l.length) return l[0];
    }
    return "";
  }

  /* opening material for every part: preset, then device default, then first */
  var fallbackCode = MATS[0].code;
  if(DATA.defaults && byCode[DATA.defaults.part]) fallbackCode = DATA.defaults.part;
  if(DEV && byCode[DEV.default_material]) fallbackCode = DEV.default_material;

  function openingPicks(){
    var picks = {};
    PARTS.forEach(function(p){
      var c = PRESET ? PRESET[p.key] : null;
      picks[p.key] = (c && byCode[c]) ? c : fallbackCode;
    });
    return picks;
  }

  return {
    DEV: DEV, PRESET: PRESET, PRESET_NAME: PRESET_NAME,
    MATS: MATS, byCode: byCode, BLANK: BLANK,
    PARTS: PARTS, SUBS: SUBS, VARS: VARS, TOKENS: TOKENS, BASE: BASE,
    ANGLES: ANGLES, angleLabel: angleLabel,
    variantForSet: variantForSet, amountOf: amountOf, symbol: symbol,
    baseFor: baseFor, layersFor: layersFor, swatchFor: swatchFor,
    openingPicks: openingPicks,
    editKey: editKey, codeByName: codeByName, addonsOfVariant: addonsOfVariant
  };
})();